import Immutable from 'seamless-immutable';
import { RETRIEVE_ACCOUNT_STATUS_CUSTOM_TILE_CONSTANTS } from './actions/custom.tiles.actions';
import { CUSTOM_TILE_TYPE } from 'invision-core/src/constants/custom.tiles.constants';
export var INITIAL_STATE = Immutable({
  data: {}
});
var TEST_SAMPLE_STRING = 'good <script>alert("go team!");</script> great customer, outstanding risk';
var MAX_RESULT_LENGTH = 40;
export function CustomTileResultReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type,
    requestObject = _ref.requestObject;
  switch (type) {
    case RETRIEVE_ACCOUNT_STATUS_CUSTOM_TILE_CONSTANTS.BEGIN:
      return state.setIn(['data', requestObject.Id], {
        key: requestObject.Id,
        value: null,
        isFetchingData: true,
        hasError: false
      });
    case RETRIEVE_ACCOUNT_STATUS_CUSTOM_TILE_CONSTANTS.SUCCESS:
      return state.setIn(['data', requestObject.Id, 'hasError'], false).setIn(['data', requestObject.Id, 'value'], validateResults(payload, requestObject)).setIn(['data', requestObject.Id, 'isFetchingData'], false);
    case RETRIEVE_ACCOUNT_STATUS_CUSTOM_TILE_CONSTANTS.FAILURE:
      {
        return state.setIn(['data', requestObject.Id, 'hasError'], true).setIn(['data', requestObject.Id, 'isFetchingData'], false);
      }
    default:
      return state;
  }
}
var validateResults = function validateResults(payload, requestObject) {
  var value = payload[requestObject.responseParam];
  if (requestObject.Type === CUSTOM_TILE_TYPE.TEXT) {
    if (requestObject.isExample) {
      // this if will catch an example text response.  this is for demo and testing purposes only.
      value = TEST_SAMPLE_STRING;
    }
    if (value.length > MAX_RESULT_LENGTH) {
      value = value.substring(0, MAX_RESULT_LENGTH);
    }
  } else if (requestObject.isExample && requestObject.Type === CUSTOM_TILE_TYPE.BOOLEAN) {
    value = value % 10 > 5;
  }
  return value;
};